import { ThunkAction } from 'redux-thunk';
import { StoreState } from '..';
import { TransfersAction, TransfersActionTypes } from './transfersTypes';
import apiRest from '../../services/apiRest';
import errorHandler from '../../errorHandler';
import { Action } from 'redux';
import { addSnackbar } from '../snacks/snacksActions';

export function getTransfers(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  Action
> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState;
      const { dateTo, dateFrom } = getState().transfersState.filters;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({
        type: TransfersActionTypes.GET_TRANSFERS_START,
      });
      const { data } = await apiRest({
        method: 'get',
        url: `/resource-transfers/`,
        params: {
          churchId,
          dateTo,
          dateFrom,
        },
      });
      dispatch({
        type: TransfersActionTypes.GET_TRANSFERS_SUCCESS,
        transfers: data,
      });
    } catch (e) {
      errorHandler(e);
      dispatch(
        addSnackbar('Houve um problema. Tente mais tarde.', {
          variant: 'error',
        })
      );
      dispatch({ type: TransfersActionTypes.GET_TRANSFERS_ERROR });
    }
  };
}

export function saveTransfer(
  form: any
): ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { transfers, selectedIndex } = getState().transfersState;
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }

      dispatch({ type: TransfersActionTypes.SAVE_TRANSFER_START });

      const transferOrig = selectedIndex !== null && transfers[selectedIndex];

      await apiRest({
        method: transferOrig ? 'PUT' : 'POST',
        url: `/resource-transfers/${transferOrig ? transferOrig.id : ''}`,
        params: { churchId },
        data: {
          ...form,
          value: parseFloat(
            form.value.replace('R$ ', '').replace('.', '').replace(',', '.')
          ),
        },
      });

      dispatch({ type: TransfersActionTypes.SAVE_TRANSFER_SUCCESS });
      dispatch(
        addSnackbar('Registro salvo com sucesso', { variant: 'success' })
      );
      dispatch(getTransfers());
    } catch (e) {
      errorHandler(e);
      dispatch(
        addSnackbar('Houve um problema. Tente mais tarde.', {
          variant: 'error',
        })
      );
      dispatch({ type: TransfersActionTypes.SAVE_TRANSFER_ERROR });
    }
  };
}

export function removeTransfer(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  Action
> {
  return async (dispatch, getState) => {
    try {
      const { selectedIndex, transfers } = getState().transfersState;
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({ type: TransfersActionTypes.REMOVE_TRANSFER_START });

      const transferOrig = selectedIndex !== null && transfers[selectedIndex];
      if (!transferOrig) {
        throw new Error();
      }

      await apiRest({
        method: 'DELETE',
        url: `/resource-transfers/${transferOrig.id}`,
        params: { churchId },
      });
      dispatch({ type: TransfersActionTypes.REMOVE_TRANSFER_SUCCESS });
      dispatch(
        addSnackbar('Registro removido com sucesso', { variant: 'success' })
      );
      dispatch(getTransfers());
    } catch (e) {
      errorHandler(e);
      dispatch(
        addSnackbar('Houve um problema. Tente mais tarde.', {
          variant: 'error',
        })
      );
      dispatch({ type: TransfersActionTypes.REMOVE_TRANSFER_ERROR });
    }
  };
}

export function editingStart(selectedIndex?: number): TransfersAction {
  return {
    type: TransfersActionTypes.EDITING_START,
    index: selectedIndex,
  };
}

export function setFilters(dateTo: string, dateFrom: string): TransfersAction {
  return {
    type: TransfersActionTypes.SET_FILTERS,
    filters: { dateTo, dateFrom },
  };
}
